import { z } from "zod";

export const FleetRangePresetSchema = z.enum(["1h", "6h", "24h", "7d", "30d"]);
export type FleetRangePreset = z.infer<typeof FleetRangePresetSchema>;

/**
 * Query params for `GET /api/workers/:hostname`.
 *
 * Callers select a window with `range` (or explicit `from`/`to`); when none
 * is provided the server defaults to the last hour.
 *
 * `bucket=auto` lets the server downsample windows >6h to ~300 points by
 * max-aggregating per-minute snapshots. `raw` returns every row.
 */
export const FleetHostHistoryQuerySchema = z.object({
	from: z.string().datetime().optional(),
	to: z.string().datetime().optional(),
	range: FleetRangePresetSchema.optional(),
	bucket: z.enum(["auto", "raw"]).default("auto"),
});
export type FleetHostHistoryQuery = z.infer<typeof FleetHostHistoryQuerySchema>;
